import { ROWS, COLUMNS } from 'src/utils/Domain/Constants';
import type { DimensionItem } from 'src/components/Mfp/PivotConfigurator/utils';
import type { TrendSummaryCardConfig } from 'src/components/Mfp/QuickTrends/TrendSummary/TrendSummary.types';
import type { TrendDetailsItem } from 'src/components/Mfp/QuickTrends/TrendDetails/TrendDetails.types';

export const API_BASE_URL = '/finplan/api' as const;

export interface ViewConfig {
  mfpApi: string;
  facets: FacetEntry[];
  title: string;
  views: {
    [view: string]: ViewEntry[];
  };
}

// @deprecated
export interface FacetEntry {
  id: string;
  displayName: string;
  pathSlot: string;
  isDefault?: boolean;
  iconSrc?: string;
  disabled: boolean | undefined;
  sortIndex?: number;
  defaultFavoritesSummaryMetrics: MacroSummaryViewConfig;
}

export interface ViewEntry {
  id: string;
  displayName: string;
  views?: ViewEntry[];
  iconClass?: string;
  isDefault?: boolean;
  description?: string;
  viewParams?: ViewParams;
  templateId?: string;
}

export interface ViewParams {
  title: string;
  summaryMetrics: MacroSummaryViewConfig;
  trendDetailsConfig?: TrendDetailsItem[];
  trendSummaryConfig?: TrendSummaryCardConfig[];
  editableChart?: ViewParams;
  [ROWS]: DimensionItem[];
  [COLUMNS]: DimensionItem[];
}

export interface MacroSummaryViewConfig {
  metrics: DimensionItem;
  revisions: DimensionItem;
}
